<template>
	<div class="padding-top padding-bottom content">
		<Loader v-if="loading" />
		<template v-else>
			<div class="flex margin-bottom">
				<h1>Discounts</h1>
				<div class="margin-left">
					<button :disabled="saving" v-on:click="create">Create</button>
				</div>
			</div>

			<table v-if="false">
				<thead>
					<tr>
						<th></th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="discount in records">
						<td>
							<a :href="'/#/discount/' + discount.id">#{{ discount.id }}</a>
						</td>
					</tr>
				</tbody>
			</table>
		</template>
	</div>
</template>

<script>
import Vue from 'vue'

export default {
  props: [],
  data: () => ({
    loading: false,
    saving: false,
    records: []
  }),
  methods: {
    load () {
      Vue.$api.get('/discounts', {}, {
        loader: toggle => this.loading = toggle,
        callback: data => this.records = data.discounts
      })
    },
    create () {
      Vue.$api.post('/discount', {}, {
        loader: toggle => this.saving = toggle,
        callback: data => this.$router.push('/discount/' + data.id)
      })
    }
  },
  created () {
    // this.load()
  }
}
</script>
